import { render, staticRenderFns } from "./SeparationAnxietyExercise.vue?vue&type=template&id=6a85a72e&"
import script from "./SeparationAnxietyExercise.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports